import { LeasingGroup as LeasingGroupType, LeasingTypeEnum } from '../../api/graphql/generated/schema';
import { LeasingGroupItemDto } from './LeasingGroupItemDto';
import { CalculationConfigDto } from '../finance/calculation/calculationConfig';

export class LeasingGroupDto {
  private readonly _type: LeasingTypeEnum;
  private _items: Array<LeasingGroupItemDto>;
  private _leasingCalculationParams?: CalculationConfigDto;

  constructor(
    type: LeasingTypeEnum,
    items: Array<LeasingGroupItemDto>,
    leasingCalculationParams?: CalculationConfigDto,
  ) {
    this._type = type;
    this._items = items;
    this._leasingCalculationParams = leasingCalculationParams;
  }

  static convertFromLeasingGroup(leasingGroup: LeasingGroupType) {
    let _items = leasingGroup.items
      ? leasingGroup.items.map((item) => LeasingGroupItemDto.convertFromLeasingGroupItem(item))
      : [];
    const leasingCalculationParams = leasingGroup.leasingCalculationParams
      ? new CalculationConfigDto(leasingGroup.leasingCalculationParams)
      : undefined;
    return new LeasingGroupDto(leasingGroup.type, _items, leasingCalculationParams);
  }

  get type(): LeasingTypeEnum {
    return this._type;
  }

  get items(): Array<LeasingGroupItemDto> {
    return this._items;
  }

  set items(value: Array<LeasingGroupItemDto>) {
    this._items = value;
  }

  get leasingCalculationParams(): CalculationConfigDto | undefined {
    return this._leasingCalculationParams;
  }

  hasAnyInvalidItem() {
    return this._items && this._items.some((item) => !item.isValid());
  }
}
